import {
  ListBalance,
  QUERY_KEY_LIST_DEBT_BALANCE,
} from '~/features/Balance/ListBalance'
import { AdditionalBalanceHeading } from '~/entities/MainBalance/ui/AdditionalBalanceHeading'
import { pushFx } from '~/shared/lib/history'
import { PageContainer } from '~/shared/ui/PageContainer'
import { useRefreshPage } from './useRefreshPage'

export function ListDebtBalancePage() {
  const { refreshPage } = useRefreshPage()

  return (
    <PageContainer
      canBack
      onBack={() => pushFx('/')}
      title='Задолженность'
      topContent={
        <AdditionalBalanceHeading balanceType='BY_DEPT' title='Задолженность' />
      }
      onRefreshPage={refreshPage}
    >
      <ListBalance
        queryKey={QUERY_KEY_LIST_DEBT_BALANCE}
        balanceType='BY_DEPT'
      />
    </PageContainer>
  )
}
